import type { PropsWithChildren } from 'react';

export function AgentAttentionPill({ children }: PropsWithChildren) {
  return (
    <span className="rounded bg-amber-500/15 px-1.5 py-0.5 text-[11px] text-amber-600 dark:text-amber-400">
      {children}
    </span>
  );
}
